<div class="form-group examfield">
  <label ng-model="vm.field.label" tabindex="-1">{{vm.field.label}}
    <span ng-if="vm.hint" class="text-danger"><i class="fa fa-warning"></i> {{vm.hint}}</span></label>
  <tags-input ng-model="vm.field.avalues"
              display-property="name"
              placeholder="Tippen zum Vervollständigen"
              add-on-comma="false"
              min-length="1"
              id="{{$id}}"
              tabindex="0"
              enable-editing-last-tag="true"
              ng-blur="vm.save()"
              replace-spaces-with-dashes="false"
              template="tag-template">
    <auto-complete source="vm.loadValues($query)"
                   min-length="0"
                   load-on-focus="true"
                   load-on-empty="true"
                   load-on-down-arrow="true"
                   max-results-to-show="32"
                   select-first-match="false"
                   template="autocomplete-template"></auto-complete>
  </tags-input>
</div>


<script type="text/ng-template" id="tag-template">
  <div class="tag-template">
    <div class="right-panel">
      <span>{{$getDisplayText()}}</span>
      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
    </div>
  </div>
</script>


<script type="text/ng-template" id="autocomplete-template">
  <div class="autocomplete-template">
    <div>
      <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>
    </div>
  </div>
</script>